var map = {
	"./gear.png": [
		1090,
		90
	],
	"./message.wav": [
		9287,
		287
	],
	"./slowgo-sm.png": [
		7092
	],
	"./slowgo.png": [
		6302
	],
	"./stone.mp3": [
		2841,
		841
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 585;
module.exports = webpackAsyncContext;